import _defineProperty from '../../node_modules/@babel/runtime/helpers/defineProperty.js';
import _objectWithoutProperties from '../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import { useMemo, cloneElement } from 'react';
import 'prop-types';
import { useReactlyticsHandlers } from '@americanexpress/reactlytics';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var eventTrackerRegexp = /on(Click|Change|Focus|Blur)/;
function ReactlyticsTracking(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var eventNamesToTrack = useMemo(function () {
    return Object.keys(props).filter(function (propName) {
      return eventTrackerRegexp.test(propName);
    }).filter(function (propName) {
      return typeof props[propName] === 'function';
    });
  }, [props]);
  var reactlyticsProps = useReactlyticsHandlers(props, eventNamesToTrack);
  var propsToClone = useMemo(function () {
    return Object.keys(reactlyticsProps).filter(function (propName) {
      return eventNamesToTrack.includes(propName);
    }).reduce(function (map, propName) {
      return _objectSpread(_objectSpread({}, map), {}, _defineProperty({}, propName, reactlyticsProps[propName]));
    }, {});
  }, [reactlyticsProps, eventNamesToTrack]);
  return /*#__PURE__*/cloneElement(children, propsToClone);
}

export default ReactlyticsTracking;
export { eventTrackerRegexp };
